"use client";

import { PropsWithChildren } from "react";
import { CedeIconRed } from "@/components/icons";
import { PortalModal } from "@/components/ui/portal-modal";

type InformationModalProps = {
  open: boolean;
  onClose: () => void;
};

export const InformationModal = ({ children, open, onClose }: PropsWithChildren<InformationModalProps>) => {
  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) {
      onClose();
    }
  };

  return (
    <PortalModal open={open} onOpenChange={handleOpenChange} showCloseButton className="sm:max-w-[560px]">
      <PortalModal.Header className="items-center gap-5 pt-1 text-center">
        <div className="relative flex items-center justify-center">
          <div className="absolute inset-0 rounded-[32px] bg-cede-error/30 blur-[70px]" aria-hidden />
          <CedeIconRed />
        </div>
        <PortalModal.Title className="px-0 text-2xl font-semibold text-cede-error">
          Important information
        </PortalModal.Title>
      </PortalModal.Header>

      <PortalModal.Content className="w-full text-left text-base leading-relaxed text-cede-text-secondary">
        <div className="space-y-4">{children}</div>
      </PortalModal.Content>
    </PortalModal>
  );
};
